// extracted by mini-css-extract-plugin
export default {"card":"PaymentReceiptCard_card__t-38C","row":"PaymentReceiptCard_row__MeuO4","viewButton":"PaymentReceiptCard_viewButton__2-527"};